import { decodeHexResponse } from '../_common/common.utils';
import AddEmployeeActionType from './AddEmployee.types';

const INITIAL_STATE: any = {
	addEmployeeResponse: null,
	employeeNameAndIDResponse: null,
};

const addEmployeeReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case AddEmployeeActionType.ADD_EMPLOYEE_START:
			return { ...state, addEmployeeResponse: null };
		case AddEmployeeActionType.ADD_EMPLOYEE_SUCCESS:
			return {
				...state,
				addEmployeeResponse: decodeHexResponse(
					action.payload,
					AddEmployeeActionType.ADD_EMPLOYEE_KEY,
				),
			};
		case AddEmployeeActionType.ADD_EMPLOYEE_FAILURE:
			return {
				...state,
				addEmployeeResponse: decodeHexResponse(
					action.payload,
					AddEmployeeActionType.ADD_EMPLOYEE_KEY,
				),
			};
		case AddEmployeeActionType.ADD_EMPLOYEE_RESPONSE_CHANGED:
			return { ...state, addEmployeeResponse: null };
		case AddEmployeeActionType.ADD_EMPLOYEE_RESPONSE_REST_START:
			return { ...state, addEmployeeResponse: null };
		case AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_START:
			return { ...state, employeeNameAndIDResponse: null };
		case AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_SUCCESS:
			return {
				...state,
				employeeNameAndIDResponse: decodeHexResponse(action.payload, 'getEmployeeKey'),
			};
		case AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_FAILURE:
			return {
				...state,
				employeeNameAndIDResponse: decodeHexResponse(action.payload, 'getEmployeeKey'),
			};
		case AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_RESPONSE_CHANGED:
			return { ...state, employeeNameAndIDResponse: null };
		case AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_RESPONSE_REST_START:
			return { ...state, employeeNameAndIDResponse: null };
		default:
			return state;
	}
};

export default addEmployeeReducer;
